<template>
  <div class="c-room-card">
    <a
      ref="root"
      class="@container relative flex flex-col justify-between box-border w-full h-full min-h-[330px] overflow-hidden rounded-2xl pt-5 px-6 pb-6 no-underline hover:no-underline focus:no-underline"
      :href="briefUrl"
      target="_blank"
      rel="noopener"
      data-test-id="concierge-search-card"
      data-concierge-touchpoint
      @click="track('click')"
    >
      <img
        class="absolute inset-0 w-full h-full object-cover"
        :src="photo"
        alt=""
        loading="lazy"
      >
      <span class="absolute inset-0 bg-[linear-gradient(180deg,rgba(23,26,28,0.15)_0%,rgba(23,26,28,0.55)_25%,rgba(23,26,28,0.95)_100%)]" />

      <p class="relative m-0 text-sm leading-5 font-semibold text-white">
        Tagvenue Concierge
      </p>

      <div class="relative flex flex-col gap-4">
        <p class="m-0 text-xl leading-7 font-semibold text-white">
          Planning a business event?<br>
          We'll negotiate the best deal
        </p>
        <p class="m-0 text-sm leading-5 text-white">
          Your own venue expert negotiates across 10,000+ venues for you, with real quotes in hours.
          Free for business events from £5k.
        </p>
        <!-- On a narrow card the specialists move above the button rather than squeeze it -->
        <div class="flex flex-col-reverse items-start gap-3 @min-[240px]:flex-row @min-[240px]:items-center @min-[240px]:justify-between">
          <span class="rounded-lg bg-green px-4 py-2.5 text-sm leading-5 font-semibold text-white whitespace-nowrap">
            Share your brief
          </span>
          <ConciergeSpecialists
            :size="32"
            :overlap="8"
            ring-class="border border-grey-50"
            online
          />
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import { CONFERENCE_PHOTO, onceVisible, PARTY_PHOTO } from '@/modules/public/shared/concierge/concierge';
import ConciergeSpecialists from '@/modules/public/shared/concierge/ConciergeSpecialists.vue';

const props = defineProps({
  briefUrl: {
    type: String,
    required: true,
  },
  eventCategory: {
    type: String,
    default: null,
  },
});

const photo = computed(() => (
  props.eventCategory === 'party' ? PARTY_PHOTO : CONFERENCE_PHOTO
));

const root = ref(null);
let stopObserving = () => {};

function track(interaction) {
  App.track.event('search_page_interaction', {
    section: 'list',
    element: 'concierge_card',
    element_value: '',
    interaction,
  });
}

onMounted(() => {
  stopObserving = onceVisible(root.value, () => track('visible'));
});

onBeforeUnmount(() => stopObserving());
</script>
